import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const humanCloneVideoUrl =
  "https://www.youtube.com/embed/AXY2i0TQD2Y?si=3N3o1gAKaiy6IpwD?rel=0&fs=1&showinfo=0";

const SiteHumanClone = () => {
  const { t } = useTranslation();

  return (
    <section id="human-clone" className=" tw-bg-slate-800">
      <Container fluid={"xl"} className=" tw-py-10">
        <Row>
          <Col className="d-flex flex-column justify-content-center align-content-center text-center align-items-center">
            <Link to={"human-clone-page"}>
              <h1 className="font-sofiaSans tw-font-extrabold md:tw-text-5xl tw-text-2xl tw-text-indigo-400">
                {t("SiteHumanClone/title")}
              </h1>
              <h5 className="font-sofiaSans tw-font-extrabold md:tw-text-2xl tw-text-lg tw-text-indigo-50">
                {t("SiteHumanClone/t-01")}
              </h5>
            </Link>
            <div className="ratio ratio-16x9 tw-max-w-2xl tw-mt-3">
              <iframe
                allow="camera; microphone"
                src={humanCloneVideoUrl}
                title="YouTube video"
                allowFullScreen
              ></iframe>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiteHumanClone;
